import { render, staticRenderFns } from "./AccountRegister.vue?vue&type=template&id=4456dd6a&scoped=true&"
import script from "./AccountRegister.vue?vue&type=script&lang=js&"
export * from "./AccountRegister.vue?vue&type=script&lang=js&"
import style0 from "./AccountRegister.vue?vue&type=style&index=0&id=4456dd6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4456dd6a",
  null
  
)

export default component.exports